import { APIGet } from "api/protocols";
import { CancelToken } from "axios";
import { IFacility } from "pages/guest/models/facility";

const apiVersion = "2024-04";
const adminType = "guest";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility";

interface IGetFacility {
  id?: number;
  short_name?: string;
  client_id?: number;
}

export async function GetFacility(params: IGetFacility, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IFacility[]>(baseUrl, params, useGlobalLoader);
}
